import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/siteTranslations';

export default function MapSection() {
  const { lang } = useLanguage();
  const t = translations[lang].location;

  return (
    <section className="py-20 bg-[#FAF7F2]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="text-xs font-semibold uppercase tracking-widest text-[#2E3191] bg-[#EEF0F8] px-3 py-1 rounded-full border border-[#2E3191]/20 inline-block mb-3">
            {t.tag}
          </span>
          <h2 className="font-serif-display text-3xl sm:text-4xl font-bold text-[#2C2825]">
            {t.title}
          </h2>
          <p className="mt-3 text-base text-[#6E6760]">
            {t.subtitle}
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          {/* Interactive Map Embed */}
          <div className="w-full rounded-2xl overflow-hidden border border-[#E8E0D7] shadow-xs min-h-[420px] bg-[#E8E0D7] relative">
            <iframe
              title="Salig Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2248.337035310619!2d12.571439!3d55.708323!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465252f205c04c63%3A0x6b8d328456f96613!2sMasned%C3%B8gade%2020%2C%202100%20K%C3%B8benhavn!5e0!3m2!1sda!2sdk!4v1700000000000!5m2!1sda!2sdk"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '420px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full h-full grayscale-[0.2] contrast-[0.95]"
            ></iframe>
            
            {/* Map Overlay Badge */}
            <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm px-4 py-2.5 rounded-xl border border-[#E8E0D7] shadow-md flex items-center gap-3">
              <i className="fa-solid fa-location-dot text-[#A86D51] text-lg" />
              <div>
                <strong className="block text-xs font-bold text-[#2C2825]">Salig – Masnedøgade 20, 2. sal</strong>
                <span className="text-[10px] text-[#6E6760]">2100 København Ø (Østerbro)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
